/* ONPTH theme scripts: countdown, cart drawer, variant picker, recommendations */
(function () {
  'use strict';
  var cfg = window.ONPTH || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- UK-time drop dates ---------- */
  var ukParts = function (date) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month - 1, d: +o.day, h: +o.hour % 24, min: +o.minute, s: +o.second };
  };
  // Returns a Date for a wall-clock time in Europe/London
  var londonDate = function (y, m, d, h, min) {
    var guess = Date.UTC(y, m, d, h, min);
    var p = ukParts(new Date(guess));
    var asUTC = Date.UTC(p.y, p.m, p.d, p.h, p.min, p.s);
    return new Date(guess - (asUTC - guess));
  };
  var dropTarget = function (el) {
    var fixed = (el.getAttribute('data-fixed') || '').trim();
    var match = fixed.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{1,2}):(\d{2})/);
    if (match) return londonDate(+match[1], +match[2] - 1, +match[3], +match[4], +match[5]);
    var day = +el.getAttribute('data-day') || 4;
    var hour = el.hasAttribute('data-hour') ? +el.getAttribute('data-hour') : 16;
    var minute = el.hasAttribute('data-minute') ? +el.getAttribute('data-minute') : 44;
    var now = new Date();
    var p = ukParts(now);
    var t = londonDate(p.y, p.m, day, hour, minute);
    if (t <= now) t = londonDate(p.y, p.m + 1, day, hour, minute);
    return t;
  };
  var formatDrop = function (date) {
    var day = date.toLocaleDateString('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'short' });
    var time = date.toLocaleTimeString('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: '2-digit', hour12: true }).replace(' ', '').toLowerCase();
    return day + ' at ' + time;
  };

  var initDrops = function () {
    $$('[data-next-drop]').forEach(function (el) {
      try { el.textContent = formatDrop(dropTarget(el)); } catch (e) { /* keep fallback */ }
    });
    $$('[data-countdown]').forEach(function (el) {
      var target;
      try { target = dropTarget(el); } catch (e) { return; }
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var fixed = (el.getAttribute('data-fixed') || '').trim() !== '';
      var tick = function () {
        var s = Math.floor((target - new Date()) / 1000);
        if (s <= 0) {
          if (fixed) {
            el.classList.add('is-live');
            el.textContent = el.getAttribute('data-live') || 'Live now';
            clearInterval(timer);
            return;
          }
          target = dropTarget(el);
          s = Math.floor((target - new Date()) / 1000);
        }
        var set = function (k, v) { var n = $('[data-cd="' + k + '"]', el); if (n) n.textContent = pad(v); };
        set('d', Math.floor(s / 86400)); s %= 86400;
        set('h', Math.floor(s / 3600)); s %= 3600;
        set('m', Math.floor(s / 60)); set('s', s % 60);
      };
      var timer = setInterval(tick, 1000);
      tick();
    });
  };

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var scrim = $('.scrim');
  var lastFocus = null;
  var openCart = function () {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    drawer.focus();
  };
  var closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  var refreshCart = function (open) {
    var url = cfg.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer-content';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-content'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.firstElementChild && tmp.firstElementChild.classList.contains('shopify-section') ? tmp.firstElementChild.innerHTML : tmp.innerHTML;
          var body = $('[data-cart-body]');
          if (body) body.innerHTML = inner;
        }
        return fetch(cfg.routes.cart + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        if (open) openCart();
      });
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && cfg.cartType === 'drawer' && drawer) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var lineBtn = e.target.closest('[data-cart-body] [data-line]');
    if (lineBtn) {
      var body = $('[data-cart-body]');
      if (body) body.classList.add('is-loading');
      fetch(cfg.routes.cartChange + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +lineBtn.getAttribute('data-line'), quantity: +lineBtn.getAttribute('data-qty') })
      }).then(function () { return refreshCart(false); })
        .finally(function () { if (body) body.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- Product form + variant picker ---------- */
  var initProduct = function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var priceEl = $('[data-price]', section);
    var stockEl = $('[data-stock-note]', section);
    var errEl = $('[data-form-error]', section);
    var picker = $('[data-variant-picker]', section);

    var selected = function () {
      return (data.options || []).map(function (_, i) {
        var c = $('input[data-option-index="' + i + '"]:checked', section);
        return c ? c.value : null;
      });
    };
    var findVariant = function (opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    };
    var markAvailability = function (opts) {
      // grey out values in the last option that have no available variant for the current earlier choices
      var last = (data.options || []).length - 1;
      if (last < 0) return;
      $$('input[data-option-index="' + last + '"]', section).forEach(function (input) {
        var test = opts.slice(); test[last] = input.value;
        var v = findVariant(test);
        input.closest('.opt').classList.toggle('is-unavailable', !v || !v.available);
      });
    };
    var update = function () {
      var opts = selected();
      opts.forEach(function (val, i) {
        var lbl = $('[data-option-label="' + i + '"]', section);
        if (lbl && val) lbl.textContent = val;
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (priceEl) priceEl.innerHTML = (v.compare ? '<s class="muted">' + v.compare + '</s> ' : '') + v.price;
      if (stockEl) stockEl.textContent = (v.qty !== null && v.qty > 0 && data.lowStock > 0 && v.qty <= data.lowStock) ? 'Only ' + v.qty + ' left in this size' : '';
      if (v.media) {
        var m = $('[data-media-id="' + v.media + '"]', section);
        var first = $('.pdp-media__item', section);
        if (m && first && m !== first) first.parentNode.insertBefore(m, first);
        $$('.pdp-media__item', section).forEach(function (n, i) { n.classList.toggle('is-first', i === 0); });
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    };
    if (picker) {
      picker.addEventListener('change', update);
      markAvailability(selected());
    }

    if (form && cfg.cartType === 'drawer' && drawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        if (addBtn) addBtn.classList.add('is-loading');
        fetch(cfg.routes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errEl) { errEl.hidden = false; errEl.textContent = res.body.description || res.body.message || 'Could not add to bag.'; }
              return;
            }
            return refreshCart(true);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      });
    }
  };

  /* ---------- Product recommendations ---------- */
  var initRecs = function () {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  };

  /* ---------- Close mobile menu on link click ---------- */
  var initMenu = function () {
    $$('.mobile-menu a').forEach(function (a) {
      a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.removeAttribute('open'); });
    });
  };

  var init = function () {
    initDrops();
    $$('[data-product-section]').forEach(initProduct);
    initRecs();
    initMenu();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-run when sections change in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initDrops();
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
